export default {
    "title": "Documentación / {{client}}",
    "availableDocuments": "Documentos disponibles",
    "document": "Documento: ",
    "download": "Descargar",
    "startDate": "Fecha de inicio: ",
    "endDate": "Fecha de caducidad: "
}